<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [model]="model"
  [hasDefault]="false"
  (valueChangeByApiName)="valueChangeByApiName($event)"
  (cancelChange)="cancel()"
  (submitChange)="saveForm()">
  <ng-container class="footer">
    <div *ngIf="haserror" class="alert alert-danger">
      <div [hidden]="!haserror">
        {{ erroremessage }}
      </div>
    </div>
  </ng-container>
  <ng-container [class.auto-width]="!currentrow?.hasAddFastCustomer" class="content">
    <div class="fcContent" [class.d-block]="hasClubCustomer" (keydown.enter)="onWrapperEnter($event)">
      <div>
        <div class="d-flex justify-content-between flex-wrap" *ngIf="!hasClubCustomer">
          <ssg-input
            *ngIf="!currentrow?.hasAddFastCustomer"
            name="Number"
            userClass="select-sm"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Parties.Customer.Code' | translate"
            [disabled]="disableNumber"
            [textType]="'number'"></ssg-input>
          <ssg-select
            name="DefaultBranches"
            userClass="select-sm"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Parties.Customer.DefaultBranch' | translate"
            [disabled]="disableNumber"
            textFieldName="Title"
            valueFieldName="Id"
            [dataList]="BranchLookUp"
            *ngIf="showDefaultBranch && (!currentrow?.hasAddFastCustomer || currentBranch.AccessToAllBranches)"
            (valueChange)="onBranchChanges($event?.Id, true)"></ssg-select>
        </div>
        <div [ngClass]="hasClubCustomer ? 'd-flex justify-content-between flex-wrap gap' : ''">
          <div class="d-flex justify-content-between flex-wrap">
            <ssg-input
              name="FirstName"
              userClass="select-sm"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Parties.Customer.Name' | translate"
              [max]="50"
              *ngIf="!hasClubCustomer"
              [disabled]="disabledTitle"></ssg-input>
            <ssg-input
              name="LastName"
              id="Lname"
              userClass="select-sm"
              [group]="formGroup"
              [required]="true"
              [max]="50"
              [label]="
                model?.Party?.PersonalityKindCode === personalityKindEnum.Legalperson
                  ? ('ClientApp.FrontOffice.Parties.Customer.Company' | translate)
                  : ('ClientApp.FrontOffice.Parties.Customer.Surname' | translate)
              "></ssg-input>
          </div>
          <div class="d-flex justify-content-between flex-wrap">
            <ssg-select
              *ngIf="!currentrow?.hasAddFastCustomer && !hasClubCustomer"
              name="NumberTypeId"
              userClass="select-sm"
              [group]="formGroup"
              [required]="true"
              textFieldName="Title"
              valueFieldName="Id"
              [dataList]="NumberTypeLookup"
              [label]="'ClientApp.FrontOffice.Parties.Customer.NumberType' | translate"
              (valueChange)="setPatternKey($event?.Code)"></ssg-select>
            <ssg-input
              name="PhoneNumber"
              userClass="select-sm"
              [group]="formGroup"
              [required]="true"
              (focusout)="getByPhoneNumber()"
              [label]="'ClientApp.FrontOffice.Parties.Customer.PhoneNumber' | translate"
              isNumberOnly="true"
              (valueChange)="onPhoneNumberChanges($event)"></ssg-input>
          </div>
        </div>
        <div class="d-flex justify-content-between adress-container flex-wrap">
          <ssg-input
            name="Address"
            userClass="select-md"
            [group]="formGroup"
            [required]="true"
            [label]="'ClientApp.FrontOffice.Parties.Customer.Address' | translate"></ssg-input>
          <ssg-button
            class="location-button"
            (click)="showMapDialog()"
            [icon]="'icon-map-marker-radius'"
            [tooltip]="'ClientApp.FrontOffice.Parties.Customer.Map' | translate"></ssg-button>
        </div>
        <ssg-input
          *ngIf="!currentrow?.hasAddFastCustomer && !hasClubCustomer"
          name="Description"
          userClass="select-md"
          [group]="formGroup"
          [label]="'ClientApp.FrontOffice.Parties.Customer.Description' | translate"></ssg-input>
        <div class="d-flex justify-content-between" *ngIf="!currentrow?.hasAddFastCustomer && !hasClubCustomer">
          <ssg-select
            name="CategoryId"
            userClass="select-sm"
            [group]="formGroup"
            [required]="true"
            [label]="'ClientApp.FrontOffice.Parties.Customer.Group' | translate"
            textFieldName="Title"
            valueFieldName="Id"
            [dataList]="customerCategories"></ssg-select>
          <ssg-select
            name="Title"
            userClass="select-sm"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Parties.Customer.Title' | translate"
            textFieldName="Title"
            valueFieldName="Id"
            apiName="Branch/ReadTitles"></ssg-select>
        </div>
        <div
          class="d-flex justify-content-between flex-wrap"
          *ngIf="
            (currentInformation.AccountingKind === SoftWareLicenseKind.AccountingAdvancedWeb ||
              currentInformation.AccountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb ||
              currentInformation.AccountingKind === SoftWareLicenseKind.AccountingWeb) &&
            !currentrow?.hasAddFastCustomer &&
            !hasClubCustomer &&
            controlsIsAdded
          ">
          <ssg-select
            name="SubLedgerId"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Parties.Customer.CertainAccount' | translate"
            userClass="select-sm"
            apiName="SubLedger/GetPagining"
            valueFieldName="Id"
            textFieldName="Title"
            textColumnsName="Title,Code"
            filterKey="Title,Code"
            IsLookup="true"
            DisplayMember="GeneralLedgerTitle"
            [columnsTitleName]="'ClientApp.FrontOffice.Parties.Customer.DefiniteCode' | translate"
            [isMultiColumns]="true"
            SortColumn="Code">
          </ssg-select>
          <ssg-select
            name="DetailLedgerId"
            [label]="'ClientApp.FrontOffice.Parties.Customer.DetailedAccount' | translate"
            [group]="formGroup"
            apiName="DetailLedger/GetPagining"
            valueFieldName="Id"
            textFieldName="Title"
            userClass="select-sm"
            textColumnsName="Title,Code"
            filterKey="Title,Code"
            [columnsTitleName]="'ClientApp.FrontOffice.Parties.Customer.DetailCode' | translate"
            [isMultiColumns]="true"
            SortColumn="Code">
          </ssg-select>
        </div>
      </div>

      <div [ngClass]="hasClubCustomer ? 'd-flex justify-content-between flex-wrap gap' : ''">
        <ssg-select
          name="ZoneId"
          [group]="formGroup"
          [ngClass]="{ custom: currentrow?.hasAddFastCustomer && !showZone, 'custom-zone': currentrow?.hasAddFastCustomer && showZone }"
          [label]="'ClientApp.FrontOffice.Parties.Customer.ZoneId' | translate"
          userClass="select-sm"
          [dataList]="zonesLookup"
          textFieldName="Title"
          valueFieldName="Id"
          [required]="true"
          (valueChange)="ZoneIdChange($event, null)">
        </ssg-select>

        <ssg-input
          *ngIf="!hasClubCustomer && !currentrow?.hasAddFastCustomer"
          name="ShippingCost"
          class="shippingCost"
          [label]="'ClientApp.FrontOffice.Parties.Customer.ShippingCost' | translate"
          textType="currency"
          [withComma]="true"
          userClass="select-sm"
          [group]="formGroup"
          required="false"
          (valueChange)="onShippingCostChanges()">
        </ssg-input>

        <ssg-input
          *ngIf="!hasClubCustomer && !currentrow?.hasAddFastCustomer"
          name="CourierShippingCost"
          [label]="'ClientApp.FrontOffice.Parties.Customer.CourierShippingCost' | translate"
          textType="currency"
          [withComma]="true"
          userClass="select-sm"
          [group]="formGroup"
          required="false"
          disabled="true">
        </ssg-input>

        <ssg-select
          *ngIf="!hasClubCustomer && !currentrow?.hasAddFastCustomer"
          name="PersonalityKindId"
          [dataList]="PersonalityKindLookup"
          [group]="formGroup"
          [label]="'ClientApp.FrontOffice.Parties.Customer.PersonalityKind' | translate"
          userClass="select-sm"
          textFieldName="Title"
          valueFieldName="Id"
          [required]="true"
          (valueChange)="PersonalityKindChange($event)">
        </ssg-select>

        <ssg-select
          *ngIf="!hasLegalCustomer && !currentrow?.hasAddFastCustomer"
          name="GenderId"
          [dataList]="GenderLookup"
          [group]="formGroup"
          [label]="'ClientApp.FrontOffice.Parties.Customer.GenderId' | translate"
          userClass="select-sm"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>

        <ssg-select
          *ngIf="isNewRow && !currentrow?.hasAddFastCustomer && !hasClubCustomer"
          name="PartyId"
          [group]="formGroup"
          [label]="'ClientApp.FrontOffice.Parties.Customer.PartyId' | translate"
          userClass="select-sm"
          apiName="Customer/ReadPartiesPagining"
          valueFieldName="Id"
          textColumnsName="Title,Number,PhoneNumber"
          filterKey="Party.Number,Party.FirstName,Party.LastName"
          [columnsTitleName]="'ClientApp.FrontOffice.Parties.Customer.CodePhone' | translate"
          [isMultiColumns]="true"
          textFieldName="Title"
          [hasDefault]="false"
          SortColumn="Party.Number"
          IsEqual="true"
          (valueChange)="PartyAccountChange($event)">
        </ssg-select>
        <ssg-input
          *ngIf="!isNewRow && !currentrow?.hasAddFastCustomer && !hasClubCustomer"
          name="DisplayName"
          [label]="'ClientApp.FrontOffice.Parties.Customer.DisplayName' | translate"
          [group]="formGroup"
          userClass="select-sm"
          required="false"
          disabled="true"
          textType="text">
        </ssg-input>
      </div>
    </div>
    <ssg-tabset
      (tabChange)="selectTab($event)"
      class="tabcontainer"
      *ngIf="defaultBranchIsInit && !currentrow?.hasAddFastCustomer && !hasClubCustomer">
      <ssg-tab active="true" [tabTitle]="'ClientApp.FrontOffice.Parties.Customer.AddressList' | translate">
        <editable-grid
          *ngIf="Addresses?.length > 0 && showAddressGrid"
          [columns]="Addresses"
          [DefaultValues]="DefaultValues"
          [noReduplicative]="true"
          (valueChanges)="valueChanges($event)"
          (formGroupValueChanges)="onAddressFormGroupValueChanges($event)"
          [dataList]="model.Addresses"
          (afterSaved)="afterSaveAddressRow($event)"
          [showMap]="true"
          (onRowSelected)="onAddressGridRowSelected($event)">
          <ssg-button
            id="toolbar-button"
            class="edit-location"
            (mousedown)="editLocation()"
            [tooltip]="'ClientApp.FrontOffice.Parties.Customer.Map' | translate"
            icon="icon-map-marker-radius"></ssg-button>
        </editable-grid>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.Parties.Customer.TelephoneList' | translate">
        <editable-grid
          #telephoneListGridEl
          *ngIf="isActveTab('ClientApp.FrontOffice.Parties.Customer.TelephoneList' | translate) && Numbers?.length > 0"
          [columns]="Numbers"
          [noReduplicative]="true"
          [DefaultValues]="DefaultValues"
          (formGroupValueChanges)="onPhoneListFormGroupValueChanges($event)"
          [dataList]="model.Numbers">
        </editable-grid>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.Parties.Customer.OccasionList' | translate">
        <editable-grid
          grid
          *ngIf="isActveTab('ClientApp.FrontOffice.Parties.Customer.OccasionList' | translate) && Occasions?.length > 0"
          [columns]="Occasions"
          [noReduplicative]="true"
          [DefaultValues]="DefaultValues"
          [dataList]="model.Occasions">
        </editable-grid>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.Parties.Customer.Details' | translate">
        <div class="row">
          <div>
            <ssg-checkbox
              id="chbIsActive"
              name="IsActive"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Parties.Customer.Active' | translate"
              required="false"
              (valueChange)="model.IsActive = $event"
              disabled="false">
            </ssg-checkbox>
          </div>
          <div>
            <ssg-checkbox
              id="FailurePaymentLink"
              name="FailurePaymentLink"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Parties.Customer.FailurePaymentLink' | translate"
              required="false"
              disabled="false">
            </ssg-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="ml-3">
            <ssg-input
              name="DeactivationReason"
              [label]="'ClientApp.FrontOffice.Parties.Customer.DeActiveReason' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              userClass="select-sm"
              maxLength="20"
              [disabled]="model.IsActive">
            </ssg-input>
          </div>
          <div class="ml-3">
            <ssg-input
              name="PercentDiscount"
              [label]="'ClientApp.FrontOffice.Parties.Customer.PercentDiscount' | translate"
              [group]="formGroup"
              userClass="select-sm"
              required="false"
              textType="number"
              (valueChange)="valueChange($event)"
              max="100"
              min="0"
              isNumberOnly="true">
            </ssg-input>
          </div>
          <div>
            <ssg-input
              *ngIf="model.Party?.PersonalityKindCode === personalityKindEnum.Realperson"
              name="NationalCode"
              [label]="NationalLabel"
              [group]="formGroup"
              userClass="select-sm"
              [required]="isNationalCodeRequired"
              isNumberOnly="true"
              textType="text"
              [patternKey]="nationalCodePattern">
            </ssg-input>
            <ssg-input
              *ngIf="model.Party?.PersonalityKindCode === personalityKindEnum.Legalperson"
              name="NationalId"
              [label]="NationalLabel"
              [group]="formGroup"
              userClass="select-sm"
              [required]="isNationalIdRequired"
              isNumberOnly="true"
              textType="text"
              [patternKey]="nationalIdPattern">
            </ssg-input>
          </div>
        </div>
        <div class="row">
          <div class="ml-3">
            <ssg-input
              name="PostalCode"
              [label]="'ClientApp.FrontOffice.Parties.Customer.PostalCode' | translate"
              [group]="formGroup"
              userClass="select-sm"
              [required]="true"
              [isDecimal]="true"
              *ngIf="hasPostalCode"
              (valueChange)="valueChange($event)"
              isNumberOnly="true"
              textType="number"
              [max]="9999999999">
            </ssg-input>
          </div>
          <div class="ml-3">
            <ssg-input
              name="EconomicCode"
              [label]="'ClientApp.FrontOffice.Parties.Customer.EconomicCode' | translate"
              [group]="formGroup"
              userClass="select-sm"
              required="false"
              *ngIf="hasEconomicCode"
              (valueChange)="valueChange($event)"
              isNumberOnly="true"
              textType="number"
              [max]="999999999999">
            </ssg-input>
          </div>
          <div>
            <ssg-input
              name="RegistrationNumber"
              [label]="'ClientApp.FrontOffice.Parties.Customer.RegistrationNumber' | translate"
              [group]="formGroup"
              userClass="select-sm"
              required="false"
              *ngIf="hasRegistrationNumber"
              (valueChange)="valueChange($event)"
              isNumberOnly="true"
              textType="number"
              [max]="99999999999999999999">
            </ssg-input>
          </div>
          <div>
            <date-picker
              id="RegistrationDate"
              name="RegistrationDate"
              [label]="'ClientApp.FrontOffice.Parties.Customer.RegistrationDate' | translate"
              [group]="formGroup"
              *ngIf="hasRegistrationDate"
              userClass="select-sm"
              required="false"
              textType="date"
              disabled="false">
            </date-picker>
          </div>
        </div>

        <div class="row" *ngIf="creditCustmer">
          <div>
            <ssg-checkbox
              id="chbHasCredit"
              name="HasCredit"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Parties.Customer.CreditCustomer' | translate"
              required="false"
              disabled="false"
              *ngIf="!DeactiveHasCreate"
              (valueChange)="CreditCourierChange($event)">
            </ssg-checkbox>
          </div>
          <div class="debtorbox">
            <div>
              <div *ngIf="hasCredit">
                <ssg-select
                  name="CreditControlTypeId"
                  [label]="'ClientApp.FrontOffice.Parties.Customer.CreditControlMethod' | translate"
                  class="credit-control-typeid"
                  userClass="select-sm"
                  apiName="Lookup"
                  [group]="formGroup"
                  systemName="SALE"
                  category="CreditControlType"
                  required="false"
                  textFieldName="Title"
                  valueFieldName="Id"
                  [disabled]="!hasCredit">
                </ssg-select>
              </div>
              <div *ngIf="hasCredit" class="credit">
                <ssg-input
                  name="CreditLimit"
                  [label]="'ClientApp.FrontOffice.Parties.Customer.MaxCredit' | translate"
                  [group]="formGroup"
                  userClass="select-sm"
                  required="false"
                  textType="currency"
                  [withComma]="true"
                  max="10000000000000000"
                  min="0"
                  [disabled]="!hasCredit">
                </ssg-input>
              </div>
            </div>
            <div *ngIf="hasCredit" class="debtor">
              <ssg-checkbox
                id="chbAutomaticDebtor"
                name="AutomaticDebtor"
                userClass="select-sm"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Parties.Customer.DebitAutomatic' | translate"
                required="false"
                [disabled]="!hasCredit">
              </ssg-checkbox>
            </div>
          </div>
        </div>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
